import api from 'api';

export const loadLookalikeAudienceTable = api(
  'POST /api/lookalikes-audiences/grid'
);
export const loadLookalikeAudienceDetails = api(
  'GET /api/lookalikes-audiences/:id/details'
);
export const loadLookalikeAudience = api('GET /api/lookalikes-audiences/:id');
export const createLookalikeAudience = api('POST /api/lookalikes-audiences');
export const deleteLookalikeAudience = api(
  'POST /api/lookalikes-audiences/:id/delete'
);
export const batchDeleteLookalikeAudience = api(
  'POST /api/lookalikes-audiences/batch/delete'
);

export const loadLookALikeAudiencesActionsLog = api(
  'GET /api/lookalikes-audiences/:id/details/actionsLog'
);
